export default "__VITE_ASSET__U$oEokwA__"